import React from 'react';
import './PoemContainer.scss';

const PoemContainer = ({ children }) => (
    <div class="post_lists">
        {children}
    </div>
);

export default PoemContainer;